interface ISocialMediaTypes {
  facebookMessenger: string;
  liff: string;
}

export const SocialMediaTypes: ISocialMediaTypes = {
  facebookMessenger: "facebookMessenger",
  liff: "liff",
};
